import { render, staticRenderFns } from "./Accomodation.vue?vue&type=template&id=97f30c84&scoped=true&"
import script from "./Accomodation.vue?vue&type=script&lang=js&"
export * from "./Accomodation.vue?vue&type=script&lang=js&"
import style0 from "./Accomodation.vue?vue&type=style&index=0&id=97f30c84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f30c84",
  null
  
)

export default component.exports